angular.module( 'acme.view.application.sherpa.customers.activity', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.sherpa.customers.activity.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var sherpaCustomersActivity = {
        name: 'application.sherpa.customers.activity',
        url: '/activity',
        views: {
          "subview-main": {
            controller: 'SherpaCustomersActivityController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/sherpa/customers/activity/activity.tpl.html'
          }
        },
        data: {
          pageTitle: 'CSR Customer Activities'
        }
      };

    $stateProvider
      .state(sherpaCustomersActivity);
});
